"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "assertText", {
  enumerable: true,
  get: function () {
    return assertText;
  }
});
var _assert = require("./assert.js");
function assertText(text, path) {
  var $ = new _assert.ObjectAssertion(text, path);
  if (!$.object()) {
    return $.errors;
  }
  $.noAdditionalProperties(['nodeType', 'data', 'value', 'marks']);
  $.object('data');
  $.each('marks', function (mark, path) {
    var mark$ = new _assert.ObjectAssertion(mark, path);
    if (!mark$.object()) {
      return mark$.errors;
    }
    mark$.string('type');
    return mark$.errors;
  });
  $.string('value');
  return $.errors;
}